<template>
  <v-card tile class="selection-background">
    <v-toolbar class="selection-background" dark>
      <v-toolbar-title>Выбор элемента</v-toolbar-title>
    </v-toolbar>

    <!-- list of types of speech structs -->

    <v-card
      v-for="SStructType in listSStructType"
      :key="'sel-sstruct-type-id-' + SStructType.id"
      @click="selSStructType = SStructType"
      class="active-sstruct-type"
      tile
    >
      <s-struct-type-info
        :s-struct-type="SStructType">
      </s-struct-type-info>
    </v-card>

    <!-- actions for selection -->

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#ec1946" class="ma-2" @click="setSelectedSStructType">
        <span class="white--text">Добавить</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SStructTypeInfo from './SStructTypeInfo'

/***
 * presentation of the selection of type of speech struct
 */

export default {
  name: 'SStructTypeSelection',
  components: { SStructTypeInfo },
  props: {
    SBlockTypeId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      /***
       * selected type of speech struct
       * */
      selSStructType: undefined
    }
  },
  computed: {
    listSStructType: ({ $store, SBlockTypeId }) => {
      return $store.getters.SBlockTypes.find(item => item.id === SBlockTypeId).speech_components
    }
  },
  methods: {
    /***
     * calls a select event
     *
     * @return { Object } selected speech struct
     * */
    setSelectedSStructType () {
      this.$emit('selected', this.selSStructType)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/colors';
  .selection-background {
    background-color: $itmo-blue!important;
  }
  .active-sstruct-type:focus {
    padding-left: 30px!important;
    background-color: $itmo-red!important;
  }
</style>
